import React, { useEffect, useState } from "react"
import { ActivityIndicator, StyleSheet, View } from "react-native"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { useNavigation, useRoute } from "@react-navigation/native"
import { fullName } from "@Utils/utils"
import VideoCallScreen from "@Components/CustomVisioContent/VideoCallScreen"
import { TouchableOpacity } from "react-native"
import Feather from "@expo/vector-icons/Feather"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import { Text } from "react-native-paper"
import AntDesign from "@expo/vector-icons/AntDesign"
import { useGenerateLiveKitToken } from "../../../Hooks/useGenerateLiveKitToken"
import { useRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"

export const AppointmentVisioContent = () => {
    const route = useRoute()
    const appointmentData = route?.params?.eventData
    const userDEUUID = route?.params?.userDEUUID
    const isDEVisio = route?.params?.isDEVisio
    const isSimpleWorkshop = route?.params?.isSimpleWorkshop
    const [visioToken, setVisioToken] = useState("")
    const navigation = useNavigation()
    const goBack = () => navigation.goBack()

    const [user, setUser] = useRecoilState(userAtom)
    const { handleFetchLiveKitToken, fetchingToken, userLiveKitToken } = useGenerateLiveKitToken()

    useEffect(() => {
        const visioData = {
            roomName: isDEVisio || isSimpleWorkshop ? userDEUUID : appointmentData?.visioconference?.uniqid,
            participantName: fullName(user?.firstName, user?.lastName)
        }

        handleFetchLiveKitToken({
            participantName: visioData?.participantName,
            roomName: visioData?.roomName
        })
    }, [isDEVisio, appointmentData])

    useEffect(() => {
        setVisioToken(userLiveKitToken)
    }, [userLiveKitToken])

    const [isAudioEnabled, setIsAudioEnabled] = useState(true)
    const [isCameraEnabled, setIsCameraEnabled] = useState(true)
    const [isScreenShareEnabled, setIsScreenShareEnabled] = useState(false)
    // const [localParticipant, setLocalParticipant] = useState(null)

    const handleLeaveRoom = () => {
        setVisioToken("")
        goBack()
    }

    const toggleMicrophone = async () => {
        await localParticipant?.setMicrophoneEnabled(!isAudioEnabled)
        setIsAudioEnabled(!isAudioEnabled)
    }

    const toggleCamera = async () => {
        await localParticipant?.setCameraEnabled(!isCameraEnabled)
        setIsCameraEnabled(!isCameraEnabled)
    }

    const toggleShareScreen = async () => {
        await localParticipant?.setScreenShareEnabled(!isScreenShareEnabled)
        setIsScreenShareEnabled(!isScreenShareEnabled)
    }

    return (
        <ContainerStackScreen style={{ backgroundColor: baseColors.white, paddingHorizontal: 0 }}>
            {fetchingToken ? (
                <View style={styles.loading}>
                    <ActivityIndicator color={baseColors.orange.primary} size={50} />
                </View>
            ) : (
                <>
                    {visioToken !== "" && (
                        <VideoCallScreen
                            token={visioToken}
                            setIsAudioEnabled={setIsAudioEnabled}
                            setIsCameraEnabled={setIsCameraEnabled}
                            handleLeaveRoom={handleLeaveRoom}
                            isAudioEnabled={isAudioEnabled}
                            isCameraEnabled={isCameraEnabled}
                            isScreenShareEnabled={isScreenShareEnabled}
                        />
                    )}
                    {/* {(!isCameraEnabled || !isAudioEnabled) && (
                        <View style={{ flex: 1 / 4, justifyContent: "center" }}>
                            {!isCameraEnabled && (
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: 10
                                    }}
                                >
                                    <AntDesign name="warning" size={20} color={baseColors.orange.primary} />

                                    <Text
                                        style={{
                                            fontStyle: "italic",
                                            marginLeft: 10,
                                            fontSize: 12,
                                            fontFamily: baseFontFamily.OpenSansSemiBold,
                                            color: baseColors.orange.primary
                                        }}
                                    >
                                        Votre camera est désactivée
                                    </Text>
                                </View>
                            )}

                            {!isAudioEnabled && (
                                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                    <AntDesign name="warning" size={20} color={baseColors.orange.primary} />

                                    <Text
                                        style={{
                                            fontStyle: "italic",
                                            marginLeft: 10,
                                            fontSize: 12,
                                            fontFamily: baseFontFamily.OpenSansSemiBold,
                                            color: baseColors.orange.primary
                                        }}
                                    >
                                        Votre micro est désactivé
                                    </Text>
                                </View>
                            )}
                        </View>
                    )} */}
                </>
            )}
        </ContainerStackScreen>
    )
}

const styles = StyleSheet.create({
    overlay: {
        marginTop: -15,
        width: "100%",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        backgroundColor: "white",
        padding: 20
    },
    row: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center"
    },
    loading: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
})
